module.exports = __webpack_public_path__ + "img/List_Interest2.5287ae88.png";